
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const ActiveStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  BLOCKED: 'BLOCKED'
} as const

export type ActiveStatus = (typeof ActiveStatus)[keyof typeof ActiveStatus]


export const Role = {
  USER: 'USER',
  AUTHOR: 'AUTHOR',
  ADMIN: 'ADMIN'
} as const

export type Role = (typeof Role)[keyof typeof Role]


export const PostStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
} as const

export type PostStatus = (typeof PostStatus)[keyof typeof PostStatus]


export const CommentStatus = {
  APPROVED: 'APPROVED',
  REJECT: 'REJECT'
} as const

export type CommentStatus = (typeof CommentStatus)[keyof typeof CommentStatus]


export const SubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  EXPIRED: 'EXPIRED',
  CANCELED: 'CANCELED'
} as const

export type SubscriptionStatus = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus]
